// Hostnames whose first DNS label is NOT a tenant subdomain. This app is
// served from energy.liftconnectpro.dev — "energy" is the product, not an
// org — so the tenant `_subdomain` header must come from
// localStorage._subdomain (written by the login response's
// userDetails.overrideSubdomain), exactly like the backoffice host works in
// flex2-webapp. Pre-login no `_subdomain` header is sent at all, which
// flex2-api treats the same as a backoffice login.
//
// Deliberately dependency-free: imported by both src/api/index.js and
// src/helpers/axiosConfig.js, which sit inside the api ↔ store ↔ helpers
// import cycle. Keeping this constant out of that cycle avoids a TDZ crash
// when setAxios() runs during store bootstrap.
export const NON_TENANT_SUBDOMAINS = new Set(["backoffice", "energy", "www"]);
